<template>
  <div class="flex w-full justify-content-center">
    <div v-if="(!loaded)"><AppSpinner /></div>
    <div v-if="(loaded)" class="flex w-full">
      <div class="flex flex-column w-full gap-3">

        <div v-if="(step >= 1)" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-start">
            <div class="msg-sent flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="content.txt[0]"></div>
              <div class="flex flex-wrap w-full justify-content-center gap-2">
                <Button v-for="(forItem, forIndex) in $store.state.param.setores" :key="forIndex" @click="mt_formSetorArea(forItem.id, null); mt_ecra(forItem.txt, content.buttons.bt_setor);" :label="forItem.txt" class="app-button" :disabled="disabled" :outlined="(forItem.id == 5 ? true : false)" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="(step < steps)" class="flex flex-column w-full">
          <div class="flex w-full justify-content-start">
            <AppThreeDots />
          </div>
        </div>

        <div v-for="(forItem, forIndex) in list" :key="forIndex" class="flex flex-column w-full fadein animation-duration-1000">
          <div class="flex w-full justify-content-end">
            <div class="msg-received flex flex-column px-3 py-2 gap-2 shadow-1">
              <div v-html="forItem.text"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: true,
      disabled: false,
      step: 0,
      steps: 1,
      list: [],
    };
  },
  props: {
    name: String,
  },
  computed: {
    content() {
      return this.$store.state.txt_app[this.name];
    },
  },
  watch: {},
  methods: {
    mt_start() {
      for (let i = 1; i <= this.steps; i++) {
        setTimeout(() => { this.mt_step(); }, (i * 400));
      }
    },
    mt_formReset() {
      this.$parent.form.novaDenuncia.setor = null;
      this.$parent.form.novaDenuncia.setorArea = null;
    },
    mt_formSetorArea(setor, setorArea) {
      this.$parent.form.novaDenuncia.setor = setor;
      this.$parent.form.novaDenuncia.setorArea = setorArea;
    },
    mt_step() {
      this.step++;
      this.$parent.mt_goBottom();
    },
    mt_ecra(text, component, restart) {
      this.disabled = true;
      
      if (text != null && text != '') {
        let item = { text: text };
        this.list.push(item);
        this.$parent.mt_goBottom();
      }

      if (restart) {
        setTimeout(() => {
          this.$parent.mt_restart();
        }, 400);
      } else {
        let ecra = { component: component };
        this.$parent.list.push(ecra);
      }
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
